import { render, staticRenderFns } from "./OrderRewardModal.vue?vue&type=template&id=4457c5f8&scoped=true&"
import script from "./OrderRewardModal.vue?vue&type=script&lang=js&"
export * from "./OrderRewardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457c5f8",
  null
  
)

export default component.exports